import './styles/assistances.css'
import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import Menu from '../components/menu'

//Extras
import { fontType, main, levelColors } from '../assets/extras'
import { collection, doc, getDoc, getDocs, orderBy, query, where } from 'firebase/firestore'
import { db } from '../assets/connections'
import { niveles, horas } from '../assets/datas'

const Assistances = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [ variables, setVariables ] = useState({
        loading: true,
        teachers: [],
        regs: [],
        conteo: 0,
        horasT: 0,
        date: new Date(),
        calendar: false
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
                            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" + 
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #56d600;'></div>"
                          : status == "warning" ?
                            "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" + 
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                          : status == "error" ?
                            "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" + 
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #c20000;'></div>"
                          : ""
        
        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Variable que almacena los datos ordenados por dias
    var sortedDaysData = [
        [], //Extras
        [], //Lunes
        [], //Martes
        [], //Miercoles
        [], //Jueves
        [], //Viernes
        [], //Sabado
        [], //Domingo
    ]

    //Funcion que busca a que dia pertenece la clase
    const sortByDay = (clase) => {
        for(let i = 0; i < 7; i++){
            if(i === 0){ //Lunes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Lunes"){
                        sortedDaysData[i+1].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 1){ //Martes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Martes"){
                        sortedDaysData[i+1].push(clase)
                        cont ++;
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 2){ //Miercoles
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Miercoles"){
                        sortedDaysData[i+1].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 3){ //Jueves
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Jueves"){
                        sortedDaysData[i+1].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 4){ //Viernes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Viernes"){
                        sortedDaysData[i+1].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 5){ //Sabado
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Sabado"){
                        sortedDaysData[i+1].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 6){ //Domingo
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Domingo"){
                        sortedDaysData[i+1].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            }
        }
    }

    //Obtener profesores
    const getTeachers = async () => {
        await getDocs(query(collection(db, "Profesores"), where("academia_profesor", "array-contains", academia), orderBy("nombre_profesor", "asc"))).then(r => {
            var aux = []
            r.docs.map((v) => {
                aux.push({
                    id: v.data().correo_profesor,
                    nombre_profesor: v.data().nombre_profesor + " " + v.data().apellido_p_profesor
                })
            })

            aux.sort((a, b) =>
                a.nombre_profesor.localeCompare(b.nombre_profesor, "es", { sensitivity: "base" })
            )

            getClasses(aux)

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funciones que obtienen las clases del profesor seleccionado
    const getClasses = async (teachers) => {
        if(teachers.length > 0){
            await getDocs(query(collection(doc(db, ref), "Clases"), where("profesor_clase", "==", teachers[0].id))).then( r => {
                var aux = []
                var sort = niveles.map(v => []) //Obtenemos un arreglo con las listas por cada nivel
                sort.push([])

                if(r.docs.length > 0){
                    r.docs.map(v => {
                        const id = v.id
                        //Validamos si es una clase normal/sustitucion o una clase extracurricular
                        if(id.split("-").length === 1 || id.split("-")[2] === "TEMP"){
                            var newObject = {
                                id: v.id,
                                nombre_clase: v.data().nombre_clase,
                                nombre_profesor: v.data().nombre_profesor,
                                nivel: v.data().nivel,
                                dias_clase: v.data().dias_clase,
                                profesor_clase: v.data().profesor_clase
                            }

                            //Ordenamos las clases por nivel
                            for(let i = 0; i < niveles.length; i++){
                                if(niveles[i] === newObject.nivel){
                                    sort[i+1].push(newObject)
                                    break
                                }
                            }
                        } else {
                            var newObject = {
                                id: v.id,
                                nombre_clase: v.data().nombre_clase,
                                nombre_profesor: v.data().nombre_profesor,
                                profesor_clase: v.data().profesor_clase
                            }
                            sort[0].push(newObject)
                        }
                    })

                    //Agregamos nuestra clase extracurricular a la lista general de clases
                    for(let i = 0; i < sort[0].length; i++){
                        aux.push(sort[0][i])
                    }

                    //Tenemos como resultado una lista de listas que tiene ordenadas las clases por niveles
                    //Ahora tenemos que ordenar cada lista de niveles por dias
                    for(let i = 1; i < sort.length; i++){

                        let clases = sort[i] //Lista de clases de alguna etapa

                        //Ordenamos cada clase de la lista de las categorias por dias
                        for(let j = 0; j < clases.length; j++){
                            //Recibimos una sola clase de la lista+
                            sortByDay(clases[j])
                        }

                        //Uva vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
                        //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
                        for(let j = 0; j < sortedDaysData.length; j++){

                            //Primero creamos una variable que contendra las horas de clase
                            var h = horas.map((v, i) => [])

                            for(let x = 0; x < sortedDaysData[j].length; x++){

                                //Creamos una variable que almacena las horas de comienzo de cada clase
                                var start = []
            
                                //Recorremos cada dia de las clases
                                for(let z = 0; z < sortedDaysData[j][x].dias_clase.length; z++){
                                    //Las agregamos a la variable de almacenamiento de las horas
                                    start.push(parseInt(sortedDaysData[j][x].dias_clase[z].de))
                                }

                                
                                //Ahora validamos recorriendo las horas a cual pertenece cada una
                                for(let z = 0; z < h.length; z++){
                                    if(start.includes((z+1))){
                                        h[z].push(sortedDaysData[j][x])
                                        break
                                    }
                                }
            
                            }

                            h.map((v, i) => {
                                v.map(v2 => {
                                    aux.push(v2)
                                })
                            })

                        }

                        //Reiniciamos nuestra variable para el ordenamiento de las clases
                        sortedDaysData = [
                            [], //Extras
                            [], //Lunes
                            [], //Martes
                            [], //Miercoles
                            [], //Jueves
                            [], //Viernes
                            [], //Sabado
                            [], //Domingo
                        ]

                    }
                }

                setVariables(prev => ({
                    ...prev,
                    teachers: teachers
                }))

                getHistory(aux)

            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Error de conexion", "error")
                }, 100)
            })
        } else {
            setVariables(prev => ({
                ...prev,
                teachers: teachers,
                loading: false
            }))
        }
        
    }
    const getClassesAux = async (teacher) => {
        await getDocs(query(collection(doc(db, ref), "Clases"), where("profesor_clase", "==", teacher))).then( r => {
            var aux = []
            var sort = niveles.map(v => []) //Obtenemos un arreglo con las listas por cada nivel
            sort.push([])
            r.docs.map(v => {
                const id = v.id
                //Validamos si es una clase normal/sustitucion o una clase extracurricular
                if(id.split("-").length === 1 || id.split("-")[2] === "TEMP"){
                    var newObject = {
                        id: v.id,
                        nombre_clase: v.data().nombre_clase,
                        nombre_profesor: v.data().nombre_profesor,
                        nivel: v.data().nivel,
                        dias_clase: v.data().dias_clase,
                        profesor_clase: v.data().profesor_clase
                    }

                    //Ordenamos las clases por nivel
                    for(let i = 0; i < niveles.length; i++){
                        if(niveles[i] === newObject.nivel){
                            sort[i+1].push(newObject)
                            break
                        }
                    }
                } else {
                    var newObject = {
                        id: v.id,
                        nombre_clase: v.data().nombre_clase,
                        nombre_profesor: v.data().nombre_profesor,
                        profesor_clase: v.data().profesor_clase
                    }
                    sort[0].push(newObject)
                }
            })

            //Agregamos nuestra clase extracurricular a la lista general de clases
            for(let i = 0; i < sort[0].length; i++){
                aux.push(sort[0][i])
            }

            //Tenemos como resultado una lista de listas que tiene ordenadas las clases por niveles
            //Ahora tenemos que ordenar cada lista de niveles por dias
            for(let i = 1; i < sort.length; i++){

                let clases = sort[i] //Lista de clases de alguna etapa

                //Ordenamos cada clase de la lista de las categorias por dias
                for(let j = 0; j < clases.length; j++){
                    //Recibimos una sola clase de la lista+
                    sortByDay(clases[j])
                }

                //Uva vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
                //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
                for(let j = 0; j < sortedDaysData.length; j++){

                    //Primero creamos una variable que contendra las horas de clase
                    var h = horas.map((v, i) => [])

                    for(let x = 0; x < sortedDaysData[j].length; x++){

                        //Creamos una variable que almacena las horas de comienzo de cada clase
                        var start = []
    
                        //Recorremos cada dia de las clases
                        for(let z = 0; z < sortedDaysData[j][x].dias_clase.length; z++){
                            //Las agregamos a la variable de almacenamiento de las horas
                            start.push(parseInt(sortedDaysData[j][x].dias_clase[z].de))
                        }

                        
                        //Ahora validamos recorriendo las horas a cual pertenece cada una
                        for(let z = 0; z < h.length; z++){
                            if(start.includes((z+1))){
                                h[z].push(sortedDaysData[j][x])
                                break
                            }
                        }
    
                    }

                    h.map((v, i) => {
                        v.map(v2 => {
                            aux.push(v2)
                        })
                    })

                }

                //Reiniciamos nuestra variable para el ordenamiento de las clases
                sortedDaysData = [
                    [], //Extras
                    [], //Lunes
                    [], //Martes
                    [], //Miercoles
                    [], //Jueves
                    [], //Viernes
                    [], //Sabado
                    [], //Domingo
                ]

            }

            getHistory(aux)

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que obtiene los registros totales del profesor de todas sus clases
    const getHistory = async (classes) => {
        var sumaT = 0
        var horasT = 0

        for(let i = 0; i < classes.length; i++){
            await getDoc(doc(doc(db, ref), "Historial", classes[i].id)).then(r => {
                getRegs(r.ref, classes[i].id).then(s => {
                    sumaT += s.registros
                    horasT += s.horas

                    if(i === classes.length-1){
                        updateData(sumaT, horasT, classes)
                    }
                })
            })
        }

        setVariables(prev => ({
            ...prev,
            loading: false
        }))

    }
    const getRegs = async (historyRef, id) => {
        var suma = 0
        var horas = 0
        await getDocs(query(collection(historyRef, "Historial"))).then(r => {
            r.docs.map(v => {
                if(v.data().duracion_clase){
                    horas += parseInt(v.data().duracion_clase)
                }
            })
            suma += r.docs.length
        })

        return new Promise((resolve) => {
            resolve({
                registros: suma,
                horas
            })
        })
    }

    const updateData = (sumaT, horasT, classes) => {
        setVariables(prev => ({
            ...prev,
            regs: classes,
            conteo: sumaT,
            horasT: horasT,
            loading: false
        }))
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getTeachers()
        }
    }, [])

    if(variables.loading)
        return (
            <Loader loading={variables.loading} />
        )

    if(!variables.loading)
    return (
        <div className='mainAssistances'>

            <Snack />

            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0
            }}>ASISTENCIAS</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -40,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingBottom: 20,
                paddingTop: 0
            }}>{
                localStorage.getItem("authToken") ? 
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

            <Menu
                academia={academia}
                reference={ref}
            />

            <div className='custom-select'>
                <select placeholder='Seleccionar profesor'
                    onChange={e => {
                        if(e.target.value != null){
                            setVariables(prev => ({
                                ...prev,
                                loading: true
                            }))
                            getClassesAux(JSON.parse(e.target.value).id)
                        }
                    }}
                >
                    <option value={null}>Seleccionar profesor</option>
                    {
                        variables.teachers.map((v) =>  {
                            return (
                                <option value={JSON.stringify({id: v.id, nombre_profesor: v.nombre_profesor})}>{v.nombre_profesor}</option>
                            )
                        })
                    }
                </select>
            </div>

            <div style={{
                marginBottom: 50
            }}>
                <p style={{
                    fontFamily: fontType.text,
                    fontSize: 18,
                    fontWeight: "bold"
                }}>{variables.conteo} clases / {variables.horasT}hrs</p>
            </div>

            <div className='contAssistances'>

                {

                    variables.regs.map((v, i) => {
                        return (
                            <ClinicCard
                                data={v}
                                reference={ref}
                                academia={academia}
                            />
                        )
                    })

                }

            </div>

        </div>
    )
}

const ClinicCard = ({data, reference, academia}) => {

    const [ subtitle, setSubtitle ] = useState("")

    //Funcion que formatea el subitulo
    const formatSubtitle = () => {
        if(data.id.split("-").length === 1 || data.id.split("-")[2] === "TEMP"){
            var dias = ""
            data.dias_clase.map(v => {
                var dia = ""
                var hora = v.de + "-" + v.a
                for(let i = 0; i < 3; i++){
                    dia += v.dia[i]
                }

                if(dias == ""){
                    dias = dia + " " + hora
                } else {
                    dias += " / " + dia + " " + hora
                }

            })

            setSubtitle(dias)
        } else {
            setSubtitle("")
        }
    }

    useEffect(() => {
        formatSubtitle()
    }, [data.dias_clase])

    //Contenedor para las clases normales
    const NormalClass = () => {
        return (
            <div className='class'>
                <p className='title' style={{
                    fontFamily: fontType.title
                }}> {data.nombre_clase} </p>
                <Link className='content' style={{ backgroundColor: 
                    data.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                    data.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                    data.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                    data.nivel == "Clase D" ? levelColors.Clase_D :
                    data.nivel == "Clase C" ? levelColors.Clase_C :
                    data.nivel == "Clase B" ? levelColors.Clase_B :
                    data.nivel == "Clase A" ? levelColors.Clase_A :
                    data.nivel == "Profesional" ? levelColors.Profesional : null
                }}
                    to={"/controlpanel/assistances/info"}
                    state={{
                        ref: reference,
                        id: data.id,
                        academia: academia
                    }}
                >
                    <p className='date' style={{
                        fontFamily: fontType.subTitle
                    }}> {subtitle} </p>
                    <p className='teacher' style={{
                        fontFamily: fontType.text
                    }}> {data.nombre_profesor} </p>
                </Link>
            </div>
        )
    }

    //Contenedor de las clases sustitutos
    const TempClass = () => {
        return (
            <div className='class'>

                <p className='title' style={{
                    fontFamily: fontType.title
                }}> {data.nombre_clase} (SUST) </p>
                <Link className='content' style={{ backgroundColor: 
                    data.nivel == "Etapa roja" ? levelColors.Etapa_roja :
                    data.nivel == "Etapa naranja" ? levelColors.Etapa_naranja :
                    data.nivel == "Etapa verde" ? levelColors.Etapa_verde :
                    data.nivel == "Clase D" ? levelColors.Clase_D :
                    data.nivel == "Clase C" ? levelColors.Clase_C :
                    data.nivel == "Clase B" ? levelColors.Clase_B :
                    data.nivel == "Clase A" ? levelColors.Clase_A :
                    data.nivel == "Profesional" ? levelColors.Profesional : null
                }}
                    to={"/controlpanel/assistances/info"}
                    state={{
                        ref: reference,
                        id: data.id
                    }}
                >
                    <p className='date' style={{
                        fontFamily: fontType.subTitle
                    }}> {subtitle} </p>
                    <p className='teacher' style={{
                        fontFamily: fontType.text
                    }}> {data.nombre_profesor} </p>
                </Link>

            </div>
        )
    }

    //Contenedor de las clases extracurriculares
    const ExtClass = () => {
        return (
            <div className='class'>

                <p className='title' style={{color: "black", fontFamily: fontType.title}}> {data.nombre_clase} (EXT) </p>
                <Link className='content'
                    to={"/controlpanel/assistances/info"}
                    state={{
                        ref: reference,
                        id: data.id
                    }}
                >
                    <p className='teacher' style={{ fontFamily: fontType.text, width: "auto", color: "black" }}> {data.nombre_profesor} </p>
                </Link>

            </div>
        )
    }

    return (
        data.id.split("-").length > 1 ?
            data.id.split("-")[2] === "TEMP" ?
                <TempClass />
            : data.id.split("-")[2] === "EXT" ?
                <ExtClass />
            : null
        : 
            <NormalClass />
    )
}

export default Assistances